import "./main_footer.css";
import logo_img from "../../img/main_logo.png";
import Delimiter from "../../util/delimiter";

function MainFooter() {
  return (
    <div className="main_footer">
      <div className="footer_logo">
        <img src={logo_img}></img>
      </div>
      <div className="footer_info">
        <div className="footer_info_detail">
          <div>시니어사랑방문요양센터</div>
          <div>대표자: 김지형</div>
          <div className="line_break" id="footer_info" hidden></div>
          <div>주소: 충남 천안시 서북구 월봉7길 49 2층 223호</div>
          <div>Tel. 041-575-7651</div>
        </div>
        <div>Copyright(c) 시니어사랑방문요양센터. All Rights Reserved.</div>
        <div>Images are Designed by Freepik</div>
      </div>
      <div className="add_info">
        <span>
          <a href="">이용약관</a>
        </span>
      </div>
    </div>
  );
}

export default MainFooter;
